import artistData from '../../data/artist.json'

export default function Biography() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
      {/* Artist Photo */}
      <div className="order-1 lg:order-2">
        <div className="sticky top-24 max-w-sm mx-auto">
          <div className="aspect-[2/4] bg-gradient-to-br from-primary/20 to-secondary/20 rounded-lg overflow-hidden shadow-xl">
            {/* Placeholder - replace with actual photo */}
            <img
              src={artistData.photo}
              alt={artistData.name}
              className="w-full h-full object-cover"
              onError={(e) => {
                // Fallback if image not found
                e.target.style.display = 'none'
                e.target.parentElement.innerHTML = `
                  <div class="flex items-center justify-center h-full p-8 text-center">
                    <div>
                      <p class="text-neutral-500 mb-2">Foto folgt in Kürze</p>
                      <p class="font-serif text-primary text-xl">${artistData.name}</p>
                    </div>
                  </div>
                `
              }}
            />
          </div>

          {/* Artist Info Card */}
          <div className="mt-6 p-6 bg-neutral-50 rounded-lg">
            <h3 className="font-serif text-2xl text-primary mb-4">{artistData.name}</h3>
            <div className="space-y-2 text-sm text-neutral-700">
              <p>
                <span className="font-semibold">Geboren:</span> {artistData.birthYear} in {artistData.birthPlace}
              </p>
              <p>
                <span className="font-semibold">Lebt und arbeitet:</span> {artistData.currentLocation}
              </p>
              <p>
                <span className="font-semibold">Medium:</span> {artistData.medium}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Biography Text */}
      <div className="order-2 lg:order-1 prose prose-lg prose-neutral max-w-none">
        <h1 className="text-4xl md:text-5xl font-serif text-primary mb-8">Vita</h1>

        {/* Split biography into paragraphs */}
        {artistData.bio.long.split('\n\n').map((paragraph, index) => (
          <p key={index} className="text-neutral-700 leading-relaxed mb-6">
            {paragraph}
          </p>
        ))}

        {/* Signature Quote */}
        <div className="mt-12 p-6 bg-primary/5 border-l-4 border-primary rounded-r-lg">
          <blockquote className="text-lg font-serif italic text-primary">
            &ldquo;{artistData.signature}&rdquo;
          </blockquote>
          <cite className="block mt-3 text-sm text-neutral-600 not-italic">
            - {artistData.name}
          </cite>
        </div>

        {/* Training and Background */}
        <div className="mt-8 space-y-4">
          <div>
            <h3 className="text-xl font-semibold text-primary mb-2">Ausbildung</h3>
            <p className="text-neutral-700">{artistData.training}</p>
          </div>

          {artistData.background && (
            <div>
              <h3 className="text-xl font-semibold text-primary mb-2">Beruflicher Hintergrund</h3>
              <p className="text-neutral-700">{artistData.background}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
